module.exports = __webpack_public_path__ + "static/media/international-map.971be1f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/international-map.jpg
// module id = 260
// module chunks = 0